// EMPLOYEE PAGES
import EmployeeViewPage from './employee/employee_view.js';
import EmployeeDashboardPage from './employee/employee_dashboard.js';
import EmployeeListPage from './employee/employee_list_new.js';
import EmployeeRedirectPage from './employee/employee_redirect.js';
import EmployeeLeavePage from './employee/employee_leave.js';
import EmployeeNotificationsPage from './employee/employee_notifications.js';
import EmployeeCreatePage from './employee/employee_create.js';
import EmployeeSearchPage from './employee/employee_search.js';

// ADMIN PAGES
import ApproveUsers from './admin/approve_users.js';
import CompaniesPage from './admin/companies.js';
import ContractTypePage from './admin/contract_type.js';
import TerminationReason from './admin/termination_reason.js';
import BranchesPage from './admin/branches.js';
import DepartmentsPage from './admin/departments.js';
import AdminDocumentCategories from './admin/document_categories.js';
import AdminEmployeeFields from './admin/employee_fields.js';
import EmployeeGroups from './admin/employee_groups.js';
import AdminGeneralDocumentCategories from './admin/general_document_categories.js';
import AdminHolidays from './admin/holidays.js';
import AdminLeaveTypes from './admin/leave_types.js';
import MobileConfiguration from './admin/mobile_configuration.js';
import RequisitionConfiguration from './admin/requisition_configuration.js';
import SurveysSetup from './admin/surveys_setup.js';
import SystemLog from './admin/system_log.js';
import SystemNotifications from './admin/system_notifications.js';
import AdminLeaveRules from './admin/leave_rules.js';
import AdminFeatureRoles from './admin/features_roles.js';
import AdminLeaveCategories from './admin/leave_categories.js';
import EditPerformanceManagement from './admin/Settings/add_edit_performance_management.js';

// HELP PAGES
import FAQ from './help/faq.js';

// DOCUMENTS PAGES
import GeneralDocuments from './documents/documents.js';
import AdminApproveDocuments from './documents/approve_documents.js';

// GENERAL PAGES
import ReportBirthdayPage from './general/birthday_report.js';
import CalendarPage from './general/calendar.js';
import ReportEmployeeCountPage from './general/employee_count_report.js';
import ReportCurrentLeavePage from './general/employees_currently_on_leave_report.js';
import ReportFutureLeavePage from './general/employees_future_leave_report.js';
import ReportEmployeeRoleListPage from './general/employee_role_list.js';
import AdminEvents from './admin/events.js';

// MANAGER PAGES
import ManagerApproveLeave from './manager/approve_leave.js';
import LeaveCancellationRequest from './manager/leave_cancellation_request.js';

// REPORTS PAGES
import ReportTakenLeaveFullPage from './report/leave_taken_report_full.js';
import ReportTakenLeavePage from './report/leave_taken_report.js';
import OutstandingDataPage from './report/outstanding_data_report.js';
import SkillsMatrixPage from './report/skillsmatrix_report.js';
import ReportDepartmentGrowthPage from './report/report_department_growth.js';
import ReportGeneralStatisticsPage from './report/report_general_statistics.js';
import ReportLeaveAvailCompanyPage from './report/report_leave_company.js';
import ReportLeaceCyclesPage from './report/report_leave_cycles.js';
import ReportLeaveDepartmentComparisonPage from './report/report_leave_department_comparison.js';
import ReportLeavePerDayPage from './report/report_leave_per_day.js';
import ReportLeavePerDepartmentEmployeesPage from './report/report_leave_per_department_people.js';
import ReportLeaveTrendsPage from './report/report_leave_trends.js';
import ReportLeavePage from './report/report_leave.js';
import ReportSickLeaveCyclesPage from './report/report_sick_leave_cycles.js';
import ReportSurveyResultsPage from './report/report_survey_results.js';
import ReportLeaveTakenByLeaveTypePage from './report/leave_taken_by_leave_type.js';
import ReportLeavePerDepartmentPage from './report/report_leave_per_department.js';
import ReportEmployeeDocumentCount from './report/employee_document_count_report.js';
import ReportEmployeeEmploymentListing from './report/employee_employment_listing_report.js';
import ReportBackupManagers from './report/report_backup_managers.js';
import ReportCompanyHierarchy from './report/report_company_hierarchy.js';
import ReportCompanyOrgChart from './report/report_company_orgchart.js';
import EmployeeAttendancePage from './report/employee_attendance_report.js';
import TargetVsActualHoursPage from './report/target_vs_actual.js';
import ReportTimeAttendanceReportPerEmployeePage from './report/time_and_attendance_per_employee_report.js';
import EmployeeFieldReport from './report/employee_field_report.js';
import ReportEmploymentEquity from './report/report_employment_equity.js';
import ReportPerfmRatings from './report/performance_management/performance_ratings_report.js';
import ReportRatingsDistribution from './report/performance_management/ratings_distribution.js';
import EmployeeDisciplinaryReport from './report/employee_disciplinary_report.js';
import Habit5Report from './report/habit_5_report.js'

// SETTINGS PAGES
import PreferencesPage from './settings/preferences.js';
import ReleaseNotes from './settings/release_notes.js';

// SURVEYS PAGES
import SurveysPage from './surveys/surveys.js';
import AnonymousSurveyPage from './surveys/anonymous_survey/anonymous_survey.js';

// WIZARD PAGES
import WizardStartPageNew from './wizard/wizard_start.js';
import WhatTodoNextPage from './wizard/what_todo_next.js';

// ACCESS DENIED
import AccessDenied from './access_denied/access_denied.js';

// TEST TRANSLATE
import TestTranslate from './test_translate_page.js';

// TIME MANAGEMENT PAGES
import TimeViewPage from './time_management/time_view.js';
import ReportTimeLoggedPage from './time_management/report_time_logged.js';
import TimeManagementSetupPage from './time_management/time_management_setup.js'; 
import TimeApprovePage from './time_management/time_approve.js';
import TimeRulesSetupPage from './time_management/time_rules.js';
import ReportEmployeeHoursPage from './time_management/report_employee_hours.js';
import reportRatingsPage from './report/performance_management/ratings_report.js';

//PERFORMANCE MANAGEMENT PAGES
import PerformanceDashboard from './performance_management/performance_dashboard.js'

export default [
	EmployeeViewPage,
	EmployeeDashboardPage,
	EmployeeListPage,
	EmployeeRedirectPage,
	EmployeeLeavePage,
	EmployeeNotificationsPage,
	EmployeeCreatePage,
	EmployeeSearchPage,
	AdminApproveDocuments,
	ApproveUsers,
	CompaniesPage,
	ContractTypePage,
	TerminationReason,
	BranchesPage,
	DepartmentsPage,
	AdminDocumentCategories,
	AdminEmployeeFields,
	EmployeeGroups,
	AdminGeneralDocumentCategories,
	AdminHolidays,
	AdminLeaveTypes,
	MobileConfiguration,
	RequisitionConfiguration,
	SurveysSetup,
	SystemLog,
	SystemNotifications,
	AdminLeaveRules,
	AdminFeatureRoles,
	AdminLeaveCategories,
	EditPerformanceManagement,

	FAQ,

	GeneralDocuments,

	ReportBirthdayPage,
	CalendarPage,
	ReportEmployeeCountPage,
	ReportCurrentLeavePage,
	ReportFutureLeavePage,
	ReportEmployeeRoleListPage,
	AdminEvents,

	ManagerApproveLeave,
	LeaveCancellationRequest,

	ReportTakenLeaveFullPage,
	ReportTakenLeavePage,
	OutstandingDataPage,
	SkillsMatrixPage,
	ReportDepartmentGrowthPage,
	ReportGeneralStatisticsPage,
	ReportLeaveAvailCompanyPage,
	ReportLeaceCyclesPage,
	ReportLeaveDepartmentComparisonPage,
	ReportLeavePerDayPage,
	ReportLeavePerDepartmentEmployeesPage,
	ReportLeaveTrendsPage,
	ReportLeavePage,
	ReportSickLeaveCyclesPage,
	ReportSurveyResultsPage,
	ReportLeaveTakenByLeaveTypePage,
	ReportLeavePerDepartmentPage,
	ReportEmployeeDocumentCount,
	ReportEmployeeEmploymentListing,
	ReportCompanyHierarchy,
	ReportCompanyOrgChart,
	EmployeeAttendancePage, 
	ReportBackupManagers,
	TargetVsActualHoursPage,
	ReportTimeAttendanceReportPerEmployeePage,
	EmployeeFieldReport,
	ReportPerfmRatings,
	ReportEmployeeHoursPage,
	ReportEmploymentEquity,
	ReportRatingsDistribution,

	PreferencesPage,
	ReleaseNotes,

	SurveysPage,
	AnonymousSurveyPage,

	WizardStartPageNew,
	WhatTodoNextPage,

	AccessDenied,
	TestTranslate,

	TimeViewPage, 
	ReportTimeLoggedPage,
	TimeManagementSetupPage,
	TimeApprovePage,
	TimeRulesSetupPage,
	reportRatingsPage,
	EmployeeDisciplinaryReport,
	Habit5Report,
	PerformanceDashboard
];
